export const faLaptopDuotone = [
  '640 512',
  `<path opacity=".4" d="M0 403.2C0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8 0-10.6-8.6-19.2-19.2-19.2L19.2 384C8.6 384 0 392.6 0 403.2zM64 96l0 240 64 0 0-240 384 0 0 240 64 0 0-240c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96z"/>
  <path d="M128 96l384 0 0 240-384 0 0-240z"/>`
]
